/**
 * 알림 헤더 컴포넌트
 */
import { CloseIcon } from './Icons';
import type { NotificationTranslations } from './constants';
import type { Notification } from './types';

interface HeaderProps {
  t: NotificationTranslations;
  notifications: Notification[];
  onClose: () => void;
  onMarkAllAsRead: () => void;
  onDeleteAll?: () => void;
}

export function Header({
  t,
  notifications,
  onClose,
  onMarkAllAsRead,
  onDeleteAll,
}: HeaderProps) {
  const hasUnread = notifications.some(n => !n.isRead);

  return (
    <div className="p-4 border-b border-border">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-lg font-medium text-foreground">
          {t.notifications}
        </h3>
        <button
          onClick={onClose}
          className="p-1 hover:bg-muted rounded-full"
          aria-label="Close notifications"
        >
          <CloseIcon className="h-4 w-4 text-muted-foreground" />
        </button>
      </div>
      {notifications.length > 0 && (
        <div className="flex items-center gap-2">
          {hasUnread && (
            <button
              onClick={onMarkAllAsRead}
              className="text-sm text-primary hover:text-primary-hover font-medium"
            >
              {t.markAllAsRead}
            </button>
          )}
          {onDeleteAll && (
            <button
              onClick={onDeleteAll}
              className="text-sm text-warning hover:text-warning/80 font-medium"
            >
              {t.deleteAll}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
